import $http from '../../../axios-instance';
import Swal from 'sweetalert2'

export async function crearSeguimiento({ commit, state, dispatch }) {
    
    await $http.post('empresas/seguimientos/crear', state.selectedSeguimiento)
        .then((response) => {
            
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 5000
            })
            state.error = false
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            commit('accionError', error.message)
        })
}
export async function mostrarSeguimiento({ commit, state, rootState }, id, requestParameters = { params: state.filtro }) {
    await $http.get(`empresas/seguimientos/mostrar/${id}`, requestParameters)
        .then((response) => {

            commit('setSeguimiento', response.data.data)
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            commit('accionError', error.message)
        })
}
export async function actualizarSeguimiento({ commit, state }) {
    
    $http.put(`empresas/seguimientos/editar/${state.selectedSeguimiento.id}`, state.selectedSeguimiento)
        .then((response) => {

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 5000
            })
            state.error = false
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            commit('accionError', error.message)
        })
}

export async function guardaImagen({ state }, data) {
    await $http.post('empresas/adjuntos-seguimientos/crear', data, {
            headers: { "Content-Type": "multipart/form-data" }
        })
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            })
            state.error = false
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            })
        })
}
export async function ListaImagen({ state,commit }, requestParameters = { params: state.imagenSeguimiento }) {
    await $http.get('empresas/adjuntos-seguimientos', requestParameters)
        .then((response) => {
            commit('setListaAdjuntos',response.data.data)
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            })
        })
}

export async function listarHallazgos({ dispatch, state }, requestParameters = { params: state.filtro }) {
    await dispatch('hallazgo/listarHallazgos', requestParameters, { root: true })
}
